import {AuthSlices} from './slices'
import * as requestFromServer from '../common/cruds'
import {callTypes, catchError, endCall, startCall} from '../common/slices'
import {cleanConfiguration} from '../configurations/slices'
import {clearUserFormDataFromSession, getTimezone, handleNotificationWithToastify} from '../../../app/services/Functional'
import * as dashboard_actions from '../common/actions'

const {actions} = AuthSlices
const API_URL = process.env.REACT_APP_API_BASE_URL

export const login = (payload: any) => (dispatch: any) => {
  dispatch(startCall({}))
  return requestFromServer
    .postRequest(`${API_URL}auth/login/`, payload)
    .then((response) => {
      return response
    })
    .catch((e) => {
      const {response} = e
      dispatch(endCall({}))
      return response
    })
}

export const handleManageUserData = (response: any) => (dispatch: any) => {
  dispatch(actions.manageUserData(response.data.data))
}

export const getUserAccess = () => (dispatch: any) => {
  dispatch(startCall({}))
  return requestFromServer.postRequest(`${API_URL}auth/user-access/`).then((response) => {
    if (!response.data.success) {
      dispatch(catchError({message: response.data.message}))
      return response.data
    }
    dispatch(actions.userAccess(response.data.data))
    dispatch(endCall({}))
    return response.data
  })
}

export const getInspectionCompanyById = (id: string, type: string) => (dispatch: any) => {
  dispatch(startCall({callType: callTypes.action}))
  return requestFromServer
    .getRequest(`${process.env.REACT_APP_API_BASE_URL}inspection_companies/${id}/${type}`)
    .then((response) => {
      dispatch(endCall({callType: callTypes.action}))
      dispatch(actions.getCompany(response.data.data))
      return response.data
    })
    .catch((error) => {
      error.clientMessage = "Can't find inspection company"
      dispatch(catchError({error, callType: callTypes.action}))
    })
}

export const getSectorList = () => (dispatch: any) => {
  dispatch(startCall({callType: callTypes.list}))
  return requestFromServer
    .getRequest(`${API_URL}sectors`)
    .then((response) => {
      dispatch(endCall({callType: callTypes.list}))
      dispatch(actions.getSectorList(response.data.data))
    })
    .catch((error) => {
      error.clientMessage = "Can't find sectors"
      dispatch(catchError({error, callType: callTypes.list}))
    })
}

export const getTeamSizeList = () => (dispatch: any) => {
  dispatch(startCall({callType: callTypes.list}))
  return requestFromServer
    .getRequest(`${API_URL}team-size`)
    .then((response) => {
      dispatch(endCall({callType: callTypes.list}))
      dispatch(actions.getTeamSizeList(response.data.data))
    })
    .catch((error) => {
      error.clientMessage = "Can't find sectors"
      dispatch(catchError({error, callType: callTypes.list}))
    })
}

export const handleLoadingState = (payload: any) => (dispatch: any) => {
  return dispatch(actions.setLoadingState(payload))
}

export const createICCompany = (payload: any) => (dispatch: any) => {
  dispatch(startCall({callType: callTypes.action}))
  dispatch(handleLoadingState(true))
  return requestFromServer
    .postRequest(`${API_URL}inspection_companies/company/sign/up`, payload)
    .then((response: any) => {
      dispatch(endCall({callType: callTypes.action}))
      if (response.data.success && response.data.code === 200) {
        dispatch(handleLoadingState(false))
        if (!response.data.data.payment_details) {
          dispatch(actions.getEnterprisePlanDialog(false))
          dispatch(actions.getSuccessDialog(true))
        } else {
          window.location.replace(response.data.data.payment_details)
        }
      } else {
        dispatch(handleLoadingState(false))
        handleNotificationWithToastify(response.data)
      }
      return response.data
    })
    .catch((error) => {
      error.clientMessage = "Can't create inspection company"
      dispatch(catchError({error, callType: callTypes.action}))
      return error
    })
}

export const closeSuccesDialog = (payload: any) => (dispatch: any) => {
  return dispatch(actions.getSuccessDialog(payload))
}

export const handleEnterprisePlanDialog = (payload: any) => (dispatch: any) => {
  return dispatch(actions.getEnterprisePlanDialog(payload))
}

export const getSubscriptionPlanList = () => (dispatch: any) => {
  dispatch(startCall({callType: callTypes.list}))
  return requestFromServer
    .getRequest(`${API_URL}subscription_plans/active/sign-up`)
    .then((response) => {
      dispatch(endCall({callType: callTypes.list}))
      dispatch(actions.getSubscriptionPlanList(response.data.data))
    })
    .catch((error) => {
      error.clientMessage = "Can't find subscription plan"
      dispatch(catchError({error, callType: callTypes.list}))
    })
}

export const verifyOTP = (payload: any) => (dispatch: any) => {
  dispatch(startCall({}))
  return requestFromServer
    .postRequest(`${API_URL}auth/validate-otp/`, payload)
    .then((response) => {
      if (!response.data.success) {
        dispatch(catchError({message: response.data.message}))
        return response.data
      }
      dispatch(actions.manageUserData(response.data.data))
      dispatch(endCall({}))
      return response.data
    })
    .catch((e) => {
      dispatch(endCall({}))
    })
}

export const resendOTP = (payload: any) => (dispatch: any) => {
  dispatch(startCall({}))
  return requestFromServer
    .postRequest(`${API_URL}auth/resend-otp/`, payload)
    .then((response) => {
      if (!response.data.success) {
        dispatch(catchError({message: response.data.message}))
        return response.data
      }
      dispatch(endCall({}))
      return response
    })
    .catch((e) => {
      dispatch(endCall({}))
    })
}

export const logout = (navigate: any) => async (dispatch: any) => {
  await requestFromServer.getRequest(`${API_URL}auth/logout/`)
  dispatch(actions.logout())
  dispatch(cleanConfiguration({}))
  dispatch(dashboard_actions.resetBillingDetails())
  dispatch(dashboard_actions.resetDashboardData())
  dispatch(actions.setIsPageLoading(false))
  dispatch(endCall({}))
  clearUserFormDataFromSession()
  localStorage.removeItem('assetName')
  navigate('/auth/login')
}

export const getToolchainCredits = (id: string) => (dispatch: any) => {
  dispatch(startCall({callType: callTypes.list}))
  return requestFromServer
    .getRequest(`${process.env.REACT_APP_API_BASE_URL}dashboard/tccs/balance?company_id=${id}`)
    .then((response) => {
      dispatch(endCall({callType: callTypes.list}))
      const balance = response.data.data.tcc_balance
      if (balance < Number(process.env.REACT_APP_TCC_BALANCE_THRESHOLD) || !balance) {
        dispatch(actions.setTCCBalanceCardStatus(true))
      } else {
        dispatch(actions.setTCCBalanceCardStatus(false))
      }
      dispatch(actions.getTCCBalance(response.data.data))
    })
    .catch((error) => {
      error.clientMessage = 'Failed to retrieve TCC credits'
      dispatch(catchError({error, callType: callTypes.list}))
    })
}

export const getInspectionCompanies = (id?: string) => (dispatch: any) => {
  dispatch(startCall({callType: callTypes.list}))
  return requestFromServer
    .getRequest(
      `${process.env.REACT_APP_API_BASE_URL}auth/get/companies/superadmin/profile/dropdown`
    )
    .then((response) => {
      const companies = response.data.data.inspection_companies
      dispatch(actions.setInspectionCompanies(response.data.data))
      if (id) {
        const activeCompany = companies.find((company: any) => company.id === id)
        if (activeCompany) {
          dispatch(actions.setActiveCompany(activeCompany))
        }
      }
      return response
    })
    .catch((error) => {
      error.clientMessage = "Can't find a list of inspection companies"
      dispatch(catchError({error, callType: callTypes.list}))
    })
}

export const checkSubscriptionExpiry = (id: string) => (dispatch: any) => {
  dispatch(startCall({}))
  const payloadData = {timezone: getTimezone()}
  return requestFromServer
    .postRequest(`${API_URL}inspection_companies/${id}/check`, payloadData as unknown as null)
    .then((response) => {
      if (!response.data.success) {
        dispatch(catchError({message: response.data.message}))
        return response.data
      }
      dispatch(actions.checkSubscriptionExpiry(response.data.data))
      dispatch(actions.renewCompanyId(id))
      dispatch(endCall({}))
      return response.data
    })
}

export const renewSubscriptionPlan = (id: string) => (dispatch: any) => {
  dispatch(startCall({}))
  return requestFromServer
    .postRequest(`${API_URL}inspection_companies/${id}/renew/plan`)
    .then((response) => {
      if (response.data.success && response.data.code === 200) {
        dispatch(handlePageLoading(false))
        dispatch(handleLoadingState(false))
        if (response.data.data.subscription_plan.paymentLink.includes('null')) {
          dispatch(actions.checkSubscriptionExpiry(true))
          dispatch(actions.renewCompanyId(null))
        } else {
          window.location.replace(response.data.data.subscription_plan.paymentLink)
        }
      }
      dispatch(endCall({}))
      return response.data
    })
    .catch((e) => {
      dispatch(endCall({}))
    })
}

export const setSubscriptionExpiry = (data: any) => (dispatch: any) => {
  return dispatch(actions.checkSubscriptionExpiry(data))
}

export const handlePageLoading = (value: boolean) => (dispatch: any) => {
  return dispatch(actions.setIsPageLoading(value))
}

export const resetData = () => (dispatch: any) => {
  dispatch(actions.logout())
}

export const handleDeleteData = () => (dispatch: any) => {
  dispatch(actions.deleteData())
}

export const setIsOTPMode = (value: boolean) => (dispatch: any) => {
  dispatch(actions.setIsOTPMode(value))
}

export const handleIsOTPSentMode = (value: boolean) => (dispatch: any) => {
  dispatch(actions.setIsOTPSentMode(value))
}

export const handleIsInOTPPage = (value: boolean) => (dispatch: any) => {
  dispatch(actions.setIsInOTPPage(value))
}

export const handleOTPMode = (payload: any) => (dispatch: any) => {
  dispatch(startCall({}))
  dispatch(actions.setOTPMode(payload.mode))
  return requestFromServer
    .postRequest(`${API_URL}auth/otp-sending-to-email-or-mobile/`, payload)
    .then((response) => {
      // dispatch(resetData())
      dispatch(endCall({}))
      return response
    })
    .catch((e) => {
      dispatch(endCall({}))
    })
}

export const handleGenerateOTP = (payload: any) => (dispatch: any) => {
  dispatch(startCall({}))
  return requestFromServer
    .postRequest(`${API_URL}auth/otp-sending-to-email-or-mobile`, payload)
    .then((response) => {
      dispatch(endCall({}))
      return response
    })
    .catch((e) => {
      dispatch(endCall({}))
    })
}

export const handleVerifyOTP = (payload: any) => (dispatch: any) => {
  dispatch(startCall({}))
  return requestFromServer
    .postRequest(`${API_URL}auth/company-sign-up-validate-otp`, payload)
    .then((response) => {
      if (!response.data.success) {
        dispatch(catchError({message: response.data.message}))
        return response.data
      }
      dispatch(endCall({}))
      return response.data
    })
    .catch((e) => {
      dispatch(endCall({}))
    })
}

export const handleResendOTP = (payload: any) => (dispatch: any) => {
  return requestFromServer
    .postRequest(`${API_URL}auth/otp-sending-to-email-or-mobile`, payload)
    .then((response) => {
      return response
    })
}

export const getUserById = (id: string, type: string) => (dispatch: any) => {
  return requestFromServer
    .getRequest(`${process.env.REACT_APP_API_BASE_URL}users/${id}/${type}`)
    .then((response) => {
      return response
    })
}

export const handlePhoneNoVerifyDialog = (value: boolean) => (dispatch: any) => {
  return dispatch(actions.setPhoneNoVerifyDialogState(value))
}

export const handleEmailVerifyDialog = (value: boolean) => (dispatch: any) => {
  return dispatch(actions.setEmailVerifyDialogState(value))
}

export const handleSignUPGenerateOTP = (payload: any) => (dispatch: any) => {
  dispatch(startCall({}))
  return requestFromServer
    .postRequest(`${API_URL}auth/company-sign-up-otp-sending-to-email-or-mobile`, payload)
    .then((response) => {
      dispatch(endCall({}))
      return response
    })
    .catch((e) => {
      dispatch(endCall({}))
    })
}

export const handleUpdateUser = (value: any) => (dispatch: any) => {
  return dispatch(actions.updateUser(value))
}

export const handleDeleteUser = () => (dispatch: any) => {
  return dispatch(actions.deleteUser())
}

export const handleTemporaryPassword = (value: any) => (dispatch: any) => {
  return dispatch(actions.setTemporaryPassword(value))
}

export const handleResetPassword = (payload: any) => (dispatch: any) => {
  dispatch(startCall({}))
  return requestFromServer
    .postRequest(`${API_URL}auth/forgot-password`, payload)
    .then((response) => {
      dispatch(endCall({}))
      handleNotificationWithToastify(response.data)
      return response
    })
    .catch((e) => {
      dispatch(endCall({}))
    })
}

export const handleExpiredCompany = (payload: any) => (dispatch: any) => {
  return dispatch(actions.setExpiredCompany(payload))
}

export const handleIsExpiredCompanyAPIcalling = (payload: any) => (dispatch: any) => {
  return dispatch(actions.setIsExpiredCompanyAPIcalling(payload))
}
